import { render, staticRenderFns } from "./refereeCard.vue?vue&type=template&id=7d01f615"
import script from "./refereeCard.vue?vue&type=script&lang=js"
export * from "./refereeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports